<template>
  <div >
    <div class="table-responsive-sm">
    <table class="table" style="min-width:800px">
      <thead>
      <tr>
        <th scope="col">일자</th>
        <th scope="col" v-if="cs_status==4">시간</th>
        <th scope="col">상품</th>
        <th scope="col">소요시간</th>
        <th scope="col">판매금액</th>
        <th scope="col">할인금액</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="travel in filtered_travel_list">
        <td>{{ travel.ct_datetime | moment("YYYY-MM-DD") }}</td>
        <td v-if="cs_status==4">{{ travel.ct_datetime | moment("HH:mm") }}</td>
        <td>
          {{travel.wr_subject}}
        </td>
        <td>{{travel.ct_usage_time}}</td>
        <template v-if="travel.cs_item_type=='1' || travel.cs_item_type=='0'">
          <td class="text-right">{{travel.ct_deposit_price | number_format}}</td>
          <td class="text-right" style="color:blue">{{travel.ct_sale_price | number_format}}</td>
        </template>
        <template v-else-if="travel.cs_item_type=='2'">
          <td colspan="2" class="text-right"><a :href="travel.cs_online_purchase_url" target="_blank">인터넷예매</a></td>

        </template>
        <template v-else-if="travel.cs_item_type=='3'">
          <td colspan="2" class="text-right">현장구매</td>

        </template>
        <template v-else-if="travel.cs_item_type=='4'">
          <td colspan="2" class="text-right">무료</td>

        </template>

      </tr>

      <tr>
        <td :colspan="cs_status==4?4:3">총합계</td>
        <td class="text-right">{{sumDepositPrice | number_format}}</td>
        <td class="text-right" style="color:blue">-{{sumSalePrice | number_format}}</td>
      </tr>

      <tr v-if="additional_discount > 0" >
        <td :colspan="cs_status==4?4:3">추가할인</td>
        <td></td>
        <td class="text-right" style="font-weight: bolder">-{{((sumDepositPrice - sumSalePrice)/100*additional_discount) | number_format}}</td>
      </tr>

      <tr v-if="price_discount > 0" >
        <td :colspan="cs_status==4?4:3">금액할인</td>
        <td></td>
        <td class="text-right" style="font-weight: bolder">-{{price_discount | number_format}}</td>
      </tr>

      <tr>
        <td :colspan="cs_status==4?4:3">입금하실 금액</td>
        <td></td>
        <td class="text-right">{{result_price| number_format}}</td>
      </tr>


      </tbody>
    </table>
    </div>
    <h4 class="text-center text-danger" v-if="cs_status==3">㈜ 여수여행센터 입금계좌번호 : 기업은행 189-961-1700</h4>

    <template v-if="view_cs_status">
      <h1>여행타임라인</h1>
      <timeline>

        <template v-for="(travel_day,ymd,index) in travel_group_by_day">

          <timeline-title>{{index+1}}일차 <span style="color:red">{{ymd}}</span></timeline-title>

          <timeline-item bg-color="#9dd8e0" v-for="travel in travel_day"  style="" :key="travel.ct_id">
            <p @click="view_detail(travel.ci_id)" style="cursor: pointer">
              {{travel.ct_datetime | moment("hh:mm")}}
              <span style="font-weight:bolder;color:red">  {{travel.wr_subject}}</span>

            </p>
            <p v-if="travel.ct_comment">참고사항 : {{travel.ct_comment}}</p>
            <p v-if="travel.ct_usage_time">예상소요시간 : {{travel.ct_usage_time}}</p>
            <p>주소 : {{travel.cs_com_addr}}</p>
            <p v-if="travel.cs_com_tel">전화번호 : {{travel.cs_com_tel}}</p>
          </timeline-item>

        </template>

      </timeline>
    </template>

    <v-dialog width="80%" height="300px" :scrollable="true"  />
  </div>



</template>

<script>

  import {Timeline, TimelineItem, TimelineTitle} from 'vue-cute-timeline'

  export default {
    props: ['wr_id','bo_table','cs_status'],
    name: "user_schedule",
    data() {
      return {
        name: '김현우',
        newOpen: '',
        travel_list: [],
        additional_discount :0
      }

    },
    computed: {
      result_price:function(){
        return (this.sumDepositPrice - this.sumSalePrice) -  ((this.sumDepositPrice - this.sumSalePrice)/100*this.additional_discount) - this.price_discount
      },
      view_cs_status: function (){
        if(this.cs_status==4){
          return true;
        }
        return false;
      },
      filtered_travel_list: function () {
        return this.travel_list;
      },
      travel_group_by_day: function () {
        var vm = this;
        var a = _.groupBy(this.travel_list, function (n) {
          return n.ct_ymd;
        });

        return a;
      },
      sumDepositPrice: function () {
        if (this.travel_list.length == 0) return 0;

        let sum = 0;
        this.travel_list.forEach(function (travel, index) {

          sum += parseInt(travel.ct_deposit_price);

        })

        return sum;
      },
      sumSalePrice: function () {
        if (this.travel_list.length == 0) return 0;

        let sum = 0;
        this.travel_list.forEach(function (travel, index) {

          sum += parseInt(travel.ct_sale_price);

        })

        return sum;
      },
    },
    methods: {
      view_detail: function (ci_id) {

        var vm = this;
        axios.post('/cs_schedule/get_item.php', {
          ci_id: ci_id
        }).then(function (response) {


          vm.$modal.show('dialog', {
            title: response.data.item_name,
            text: response.data.content,

            buttons: [

              {
                title: '닫기'
              }
            ]
          })
        })
          .catch(function (error) {
            alert(error.response.data);
          }).then(() => {

        })


      },
      leaving: function (event) {
        event.returnValue = "event seems to need to be set";
        //debugger;
        alert("Leaving...");
      },


      getSchedules: function () {
        var vm = this;
        axios.post('/cs_schedule/get_schedules.php', {
          wr_id: vm.wr_id,bo_table:vm.bo_table
        }).then(function (response) {

          vm.travel_list = response.data.travel_list;
          vm.additional_discount = response.data.additional_discount;
          vm.price_discount = response.data.price_discount;
        })
          .catch(function (error) {
            alert(error.response.data);
          }).then(() => {

        })
      }
    },

    mounted: function () {
      this.getSchedules();

    },
    created: function () {
      let vm = this;
      window.onbeforeunload = function () {
        vm.newOpen.close();

      }

    },
    watch: {
      schedule_list: {
        handler: function (after, before) {
          var vm = this;
          let changed = after.filter(function (p, idx) {
            return Object.keys(p).some(function (prop) {
              return p[prop] !== vm.$data.schedule_list[idx][prop];
            })
          })
        },
        deep: true
      }
    },
    components: {
      Timeline,
      TimelineItem,
      TimelineTitle
    }
  }
</script>

<style scoped>
  p {
    padding: 0;
  }

  thead th {
    border: 1px solid #ececec;
  }

  .table th, .table td {
    text-align: center;
    padding: 5px;
  }


</style>



// WEBPACK FOOTER //
// src/pages/user_schedule.vue